import { IoClose } from "react-icons/io5";
import { AiOutlinePlus } from "react-icons/ai";
import { DefaultValueCountry, InputField } from "../../components";
import Functions from "./index.function";
const ContactInformation = ({
  register,
  errors,
  setValue,
  control,
  links,
  setLinks,
  selectedPlatform,
  setSelectedPlatform,
  linksErrors,
  setLinksErrors,
  setCountryCode,
  setCca2
}) => {
  const { userprofile, socialPlatforms, addLink, updateLink, removeLink } =
    Functions(
      links,
      setLinks,
      selectedPlatform,
      setSelectedPlatform,
      setLinksErrors
    );
  return (
    <div className={"flex flex-col xs:w-full sm:w-[90%] lg:w-[60%] mx-auto"}>
      <div className="relative w-full">
        <DefaultValueCountry
          control={control}
          label="Phone Number"
          type="text"
          name="mobile_number"
          isMandatory={true}
          defaultValue={userprofile?.mobile_num}
          countryCode={userprofile?.country_code}
          cca2={userprofile?.cca2}
          register={register}
          onChange={(value) => setValue("mobile_number", value)}
          errors={errors}
          setCountryCode={setCountryCode}
          setCca2={setCca2}
        />
      </div>
      
      <div className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 xs:pt-1 lg:pt-1">
        <div className="xs:text-sm sm:text-base font-onestRegular text-secondary">
          Social Media Profiles
        </div>

        {/* Dropdown & Add Button */}
        <div className="flex items-center xs:gap-x-2.5 sm:gap-x-3 my-2">
          <select
            value={selectedPlatform}
            onChange={(e) => setSelectedPlatform(e.target.value)}
            className="xs:text-sm sm:text-base bg-[#212121] text-[#B4B4B4] border border-goldMetallic rounded-full px-3 py-1.5 outline-none"
          >
            <option value="">Select Platform</option>
            {socialPlatforms.map((platform) => (
              <option key={platform} value={platform}>
                {platform}
              </option>
            ))}
          </select>

          <button
            type="button"
            onClick={addLink}
            className="xs:px-3 flex items-center bg-[#171717] xs:py-1.5 sm:py-2 sm:px-4 rounded-full text-secondary border border-goldMetallic transition duration-300 delay-100"
          >
            <span className="xs:text-sm sm:text-base font-onestRegular">
              Add link
            </span>
            <AiOutlinePlus className="xs:text-sm sm:text-base ml-3 text-goldMetallic" />
          </button>
        </div>
        <div className="flex justify-start items-center xs:pt-[2px] sm:pt-1">
          {linksErrors.platform && (
            <div className="text-orangeCrayola font-onestRegular xs:!text-[10px] sm:text-xs">
              {linksErrors.platform}
            </div>
          )}
        </div>
        {/* Dynamic Link Inputs */}
        {links.map((link) => (
          <>
            <div
              key={link.id}
              className="flex flex-col sm:flex-row sm:items-center sm:justify-between xs:pt-1.5 sm:pt-2 xs:w-4/5 sm:w-2/4 gap-1 sm:gap-x-3"
            >
              <input
                className="xs:rounded-[10px] sm:rounded-xl w-full sm:px-3 xs:py-1 xs:px-2 sm:py-2 bg-[#212121] text-[#B4B4B4] outline-none"
                type="text"
                placeholder={`Enter ${link.platform} link`}
                value={link.url}
                onChange={(e) => updateLink(link.id, e.target.value)}
              />
              <div
                onClick={() => removeLink(link.id)}
                className="group flex justify-center items-center xs:!w-[25px] xs:h-[22px] sm:w-7 sm:h-6 lg:w-8 lg:h-7 rounded-full bg-goldMetallic cursor-pointer transform transition-transform duration-300 hover:scale-110 hover:bg-red-700"
              >
                <IoClose className="text-black xs:text-lg sm:text-xl lg:text-2xl transform transition-transform duration-300 group-hover:rotate-180" />
              </div>
            </div>
            <div className="flex justify-start items-center xs:pt-[2px] sm:pt-1">
              {linksErrors.links[link.id] && (
                <span className="text-orangeCrayola font-onestRegular xs:!text-[10px] sm:text-xs">
                  {linksErrors.links[link.id]}
                </span>
              )}
            </div>
          </>
        ))}
      </div>
      <div className="relative w-full">
        <InputField
          control={control}
          label="Website (URL)"
          type="text"
          name="talentWebsite"
          maxLength={100}
          {...register("talentWebsite", {
            // required: 'Website is required',
            maxLength: {
              value: 100,
              message: "Website URL must be 100 characters or less",
            },
            pattern: {
              value: /^(https?:\/\/)?(www\.)?[\w-]+(\.[\w-]+)+([\/?].*)?$/i,
              message: "Please enter a valid URL (e.g., https://example.com)",
            },
          })}
          onChange={(value) => setValue("talentWebsite", value)}
          errors={errors}
        />
      </div>
    </div>
  );
};

export default ContactInformation;
